/**
 * OrderStore — 사용자PC(/u/orders) 오더목록의 클라이언트측 데이터 스토어(싱글톤).
 *
 *   엑셀형 오더 테이블이 다루는 오더배열·오더번호↔인덱스 맵·컬럼 필터·검색 날짜범위·
 *   현재 선택오더를 보관한다. (세금 로직 아님 — 오해를 주던 구 명칭 OrderTax 를 OrderStore 로 개명.)
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 최상단의 `class OrderTax` + `const orderTax = get_instance()`
 * 를 이 파일로 이관했다. u-order-list.js / u-order-edit.js 의 다수 함수가 전역 `orderTax`
 * (인스턴스)를 런타임에 참조하므로, $j.Pages.Desktop.Orders.initialize() 가 초기 부트스트랩
 * (블레이드 window.__ordersPageBoot → search()) 이전에 window.orderTax 로 노출한다.
 * (전역 인스턴스명 `orderTax` 는 레거시 호환을 위해 그대로 유지한다.)
 */
export default class OrderStore {
    constructor() {
        this.init();
    }

    /**
     * 싱글톤 패턴
     * @returns {*}
     */
    static get_instance() {
        if (!OrderStore.instance) {
            OrderStore.instance = new OrderStore();
        }
        return OrderStore.instance;
    }

    /**
     * 초기화
     */
    init = ()=>{
        this.start_date=null;// 서버에 요청한 시작일
        this.end_date=null;// 서버에 요청한 종료일
        this.init_order_list();
        this.init_filter();
    }
    /**
     * 오더목록 초기화
     */
    init_order_list = () =>{
        this.list = [];// 오더 DB 정보 (오더배열)
        this.onum_idx_map = []; // 오더번호 -> 인덱스 맵
        this.current_ordernum = 0; // 선택해서 팝업창을 띄운 오더번호
    }
    /**
     * 필터 초기화
     */
    init_filter = ()=>{
        // 화면상에 표시되는 컬럼목록 ( 컬럼명:컬럼번호 )
        //                        1     2     3    4        5      6       7      8      9     10    11   12     13       14       15         16        17         18
        this.show_columns1 = ["", "번호","차량","날짜","현장주소","거래처","현장번호","발주자","수주자","경비","상태","시간","추가","장비대금", "결제유무", "계산서유무", "상대거래", "결제메모","본사"];
        this.show_columns2 = {}; // 컬럼명으로 인덱스 찾는 배열
        this.show_columns1.forEach((v,k)=>{
            this.show_columns2[v] = k;
        });
        this.filter_list = {};// 컬럼별 필터목록
    }
    /**
     * 특정 컬럼에 필터링 추가
     * @param column
     * @param arr
     */
    update_column_filter = (column, arr)=>{
        this.filter_list[column]=[];
        arr.forEach((v)=>{
            this.filter_list[column].push(v);
        });
    }
    /**
     * 특정컬럼 필터링 초기화
     * @param column
     */
    reset_column_filter = (column)=>{
        this.filter_list[column]=[];
    }

    /**
     * 오더 목록 전체를 업데이트한다.
     * @param order_list
     */
    update_list = (order_list)=>{
        this.init_order_list();
        let i=0;
        order_list.forEach((row)=>{
           this.list[ i ]=row;
            this.onum_idx_map[row.onum]=i;
           i++;
        });
    }
    /**
     * 검색범위 날짜를 업데이트한다.
     * @param start_date
     * @param end_date
     */
    update_date = (start_date, end_date) =>{
        this.start_date=start_date;
        this.end_date=end_date;
    }
    find_idx = (ordernum) => {
        return this.onum_idx_map[ordernum];
    }
    /**
     * 오더번호로 order_info 를 찾는다.
     * @param ordernum
     * @returns {*}
     */
    find_order = (ordernum) => {
        return this.list[ this.onum_idx_map[ordernum] ];
    }
    /**
     * 특정 오더를 업데이트한다.
     * @param order_info
     */
    update_order = (order_info) => {
        let ordernum=order_info.onum;
        this.list[this.onum_idx_map[ordernum]]=order_info;
    }
    /**
     * 오더들을 업데이트한다.
     * @param order_list
     */
    update_orders = (order_list) => {
        order_list.forEach((order_info)=>{
            this.update_order(order_info);
        });
    }
    get_current_order_info = ()=>{
        // console.log('current_ordernum',this.current_ordernum);
        if(!this.current_ordernum) return null;
        return this.list[this.onum_idx_map[this.current_ordernum]];
    }
}
